import React, { useMemo } from 'react';

import moment from 'moment';
import { reviewsFormat } from '@/pages/opinion/utils/value';
import useHoverEvent from '@/pages/opinion/hooks/useHoverEvent';
import UserInfoItem from '@/pages/opinion/components/Snippets/UserInfoItem';
import RenderImg from '@/pages/opinion/components/RenderImg';
import videoCover from '@op/assets/svg/video-cover.svg';
import { getFeedsContentText } from '@/pages/opinion/utils/languageValue';
import VideoPlayIcon from '@/pages/opinion/assets/imgs/post-video-play.png';
import './index.scss';
import { connect, useIntl } from 'umi';
import { dealwithBiLiBiLiImage } from '@/pages/opinion/utils/cdnUrl';

function CardPost({
  info,
  channel,
  userInfo,
  iconLoading,
  itemClick,
  languageType,
  wholeGameInfo,
}: any) {
  const renderScores = () => {
    const scoresMaps = [
      {
        key: 'engagement',
        text: 'Engagements',
      },
      {
        key: 'tweets_like',
        text: 'Likes',
      },
      {
        key: 'tweets_reply',
        text: 'Comments',
      },
      {
        key: 'tweets_retweet',
        text: 'Shares',
      },
    ];

    const { formatMessage } = useIntl();
    return (
      <div className="dbo-accounts-post-ft">
        {scoresMaps.map((item) => (
          <div className="dbo-accounts-post-numbox" key={item.key}>
            <span className="dbo-accounts-post-num">
              {reviewsFormat(info?.[item.key] ?? 0)}
            </span>
            <span className="dbo-accounts-post-numtit">
              {formatMessage({ id: item.text })}
            </span>
          </div>
        ))}
      </div>
    );
  };

  const { contentImg, defaultImg, media_type } = useMemo(() => {
    const { media_type, video_detail, image } = info;
    let result = image?.split?.('|')?.[0];
    try {
      if (media_type === 'video') {
        const { cover_image } = JSON.parse(video_detail || '{}');
        result = cover_image;
      }
    } catch (error) { }
    const entity_image = videoCover;

    return {
      contentImg: result,
      defaultImg: entity_image,
      media_type,
    };
  }, [info]);

  const [username, url, cover_image] = useMemo(() => {
    const { anchor_name, anchor_url, cover_image } = userInfo || {};

    return [anchor_name, anchor_url, cover_image];
  }, [userInfo]);

  const openUserHomepage = (event?: any) => {
    if (!url) return;
    window.open(url);
    event?.stopPropagation();
    event?.preventDefault();
  };

  const openVideoPage = (event?: any) => {
    itemClick(info);
    event?.stopPropagation();
    event?.preventDefault();
  };

  const { isHover, onMouseenter, onMouseleave } = useHoverEvent({});

  return (
    <a
      href={info.content_url}
      onClick={(e) => e.preventDefault()}
      className={`dbo-accounts-post-wrapper`}
    >
      <div
        onMouseEnter={onMouseenter}
        onMouseLeave={onMouseleave}
        onClick={openVideoPage}
        // style={{
        //   borderColor: isHover
        //     ? channelColorMap[channel?.name?.toLocaleLowerCase()]
        //     : '#dddddd',
        // }}
        className={`dbo-accounts-post `}
      >
        <div className="dbo-accounts-post-cover">
          <RenderImg
            className="dbo-accounts-post-cover"
            defaultImage={defaultImg}
            coverImage={dealwithBiLiBiLiImage(contentImg)}
            onClick={openVideoPage}
            aigc={info?.aigc === 1}
          />

          {media_type === 'video' && (
            <img className="dbo-accounts-post-videoplay" src={VideoPlayIcon} />
          )}
        </div>

        <div className="dbo-accounts-post-infobox">
          <div className="dbo-accounts-post-hd">
            <UserInfoItem
              onClick={openUserHomepage}
              iconClick={openUserHomepage}
              icon={cover_image}
              loading={iconLoading}
              name={username || info.reviewer || '-'}
              // 新加分享属性  ---链接
              shareUrl="111"
              isLink
            ></UserInfoItem>
            <span className="dbo-accounts-post-time">
              {info.comment_time
                ? moment(info.comment_time).format('YYYY-MM-DD HH:mm:ss')
                : '-'}
            </span>
          </div>

          <div className="dbo-accounts-post-bd">
            <span className="dbo-accounts-post-des">
              {getFeedsContentText(info, languageType)}
            </span>
          </div>
          {renderScores()}
        </div>
      </div>
    </a>
  );
}

export default connect((state: any, ownProps: any) => {
  const { opinionCommon } = state;
  return {
    wholeGameInfo: ownProps?.wholeGameInfo ? ownProps?.wholeGameInfo : opinionCommon.wholeGameInfo,
  };
})(CardPost);
